/* eslint-disable no-param-reassign */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { withAccount } from '../../../components/AccountContext';
import { superlinkMetaDataQuery } from './SuperlinkImportQuery';
import { growlErrors, growlActionSuccess } from '../../../utils/NotificationUtil';
import { Loading } from '../../../components/Loading';
import {
  removeFileImport,
  activateSuperLinkImport,
  uploadSuperlinkRespondents,
} from '../../../services/apps/RespondentServices';
import { GRAPHQL_EXCEPTION_CODE } from '../../../shared/Constants';
import { getObjectFromQueryParam } from '../../../utils/UrlUtil';
import SuperlinkImportListContainer from './import-list/SuperlinkImportListContainer';
import { intlShape, matchShape, growlShape } from '../../../components/prop-types';
import { withGrowl } from '../../../components/GrowlNotifications';
import UploadFormContainer from './UploadFormContainer';
import ImportConfirmModal from './components/ImportFileDetail/ImportConfirmModal';
import SuperLinkDeleteImport from './SuperLinkDeleteImport';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  importHeader: {
    id: 'res_import.file_field_label',
    defaultMessage: 'Import Respondents',
  },
});

class SuperlinkRespondentImport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileUploaded: null,
      isActiveModal: false,
      isCancel: true,
      idActive: null,
      isOverwrite: false,
      isDeleteModal: false,
      idRemove: null,
    };
    this.openActiveModal = this.openActiveModal.bind(this);
    this.rejectActive = this.rejectActive.bind(this);
    this.openShowLogModal = this.openShowLogModal.bind(this);
    this.openRemoveModal = this.openRemoveModal.bind(this);
    this.rejectRemoveModal = this.rejectRemoveModal.bind(this);
    this.acceptActive = this.acceptActive.bind(this);
    this.changeOverwrite = this.changeOverwrite.bind(this);
    this.acceptRemoveModal = this.acceptRemoveModal.bind(this);
    this.openDefinitionModal = this.openDefinitionModal.bind(this);
    this.importRespondents = this.importRespondents.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.clearFileUpload = this.clearFileUpload.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { error } = nextProps.viewSuperlink;
    if (error) {
      const ex = {
        err: error,
        type: GRAPHQL_EXCEPTION_CODE,
      };
      throw ex;
    }
  }

  openActiveModal(id) {
    this.setState({
      isActiveModal: true,
      isCancel: true,
      idActive: id,
      isOverwrite: false,
    });
  }

  rejectActive() {
    this.setState({ isActiveModal: false });
  }

  openShowLogModal() {
    this.setState({ isCancel: false });
  }

  openRemoveModal(id) {
    this.setState({ isDeleteModal: true, idRemove: id, isCancel: true });
  }

  rejectRemoveModal() {
    this.setState({ isDeleteModal: false });
  }

  async acceptActive() {
    const { match, growl } = this.props;
    const { idActive, isOverwrite } = this.state;
    const superlinkId = match.params.superLinkId;
    const input = {
      importId: idActive,
      superLinkId: superlinkId,
      overwrite: isOverwrite,
    };
    this.setState({ isActiveModal: false });
    try {
      await activateSuperLinkImport(input);
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  async acceptRemoveModal() {
    const { currentAccount, growl, intl } = this.props;
    const { idRemove } = this.state;
    const { formatMessage } = intl;
    const input = {
      importId: idRemove,
      accountId: currentAccount,
    };
    this.setState({ isDeleteModal: false });
    try {
      await removeFileImport(input);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  changeOverwrite(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({ isOverwrite: value });
  }

  openDefinitionModal() {
    this.setState({ isCancel: false });
  }

  uploadFile(evt) {
    const { files } = evt.target;
    if (files) {
      const file = files[0];
      this.setState({
        fileUploaded: file,
      });
    }
  }

  clearFileUpload() {
    this.setState({
      fileUploaded: null,
    });
  }

  importRespondents(evt) {
    evt.preventDefault();

    const { fileUploaded } = this.state;
    const {
      growl, match, currentAccount, intl,
    } = this.props;
    const { formatMessage } = intl;
    const { superLinkId } = match.params;
    uploadSuperlinkRespondents(fileUploaded, {
      accountId: currentAccount,
      superLinkId,
    }).then((res) => {
      const { errors } = res;

      if (errors) {
        growlErrors(growl, errors);
      } else {
        growlActionSuccess(growl, formatMessage(messages.successNoti));
      }
      this.setState({
        fileUploaded: null,
      });
    });
  }

  render() {
    const { isActiveModal, isCancel, isDeleteModal } = this.state;
    const { viewSuperlink } = this.props;
    const { loading, account } = viewSuperlink;

    if (loading || !account) {
      return <Loading />;
    }
    const { superLink } = account;
    if (superLink) {
      return (
        <>
          <div className="p-grid">
            <div className="p-col-12">
              <div className="brand-detailed-wrapper">
                <div className="p-grid">
                  <div className="p-col-12">
                    <UploadFormContainer />
                  </div>
                  <div className="p-col-12">
                    <SuperlinkImportListContainer />
                  </div>
                </div>
                <ImportConfirmModal
                  modalOpen={isActiveModal}
                  reject={this.rejectActive}
                  confirm={this.acceptActive}
                  isCancel={isCancel}
                />
                {/* Delete Import File Modal */}
                <SuperLinkDeleteImport
                  modalOpen={isDeleteModal}
                  reject={this.rejectRemoveModal}
                  confirm={this.acceptRemoveModal}
                  isCancel={isCancel}
                />
              </div>
            </div>
          </div>
        </>
      );
    }
    return <Loading />;
  }
}

SuperlinkRespondentImport.propTypes = {
  viewSuperlink: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { history } = ownProps;
  const { search } = history.location;
  const queryObject = getObjectFromQueryParam(search);
  return {
    queryObject,
  };
};

export default withGrowl(
  injectIntl(connect(mapStateToProps)(withRouter(withAccount(superlinkMetaDataQuery(SuperlinkRespondentImport))))),
);
